// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { createStyles, makeStyles } from "@material-ui/core";

export interface LoadingOverlayProps {
  title: string;
  isOpen: boolean;
}

const useStyle = makeStyles(theme =>
  createStyles({
    backdrop: {
      zIndex: 0,
      color: "white",
      flexDirection: "column",
    },
    title: {
      margin: "20px",
    },
  })
);

export default ({ isOpen, title }: LoadingOverlayProps) => {
  const classes = useStyle();
  return (
    <Backdrop open={isOpen} className={classes.backdrop}>
      <div className={classes.title}>{title}</div>
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};
